exports.components = {
  "component---components-file-page-index-js": () => import("./../../../components/FilePage/index.js" /* webpackChunkName: "component---components-file-page-index-js" */)
}

